// v2 nested content (children) would be silently destroyed by v1 editing —
// v1 editors flip read-only when any top-level block carries children
export const contentHasNestedBlocks = (levels: unknown): boolean =>
    Array.isArray(levels) && levels.some((level) => Array.isArray(level?.children) && level.children.length > 0);

// v2 publish normalizes editor artifacts away (NormalizeLevelTree drops
// `edit` + `attributes`) — v1 hydrates them back from the types registry
interface TypeInfoLike {
    edit?: string | null;
    attributes?: unknown[] | null;
}

interface LevelLike {
    useBlock?: unknown;
    edit?: string | null;
    attributes?: unknown[] | null;
}

const isSharedBlockLevel = (level: LevelLike): boolean =>
    Boolean(level.useBlock) && level.useBlock !== '0' && level.useBlock !== 0;

export const resolveLevelEdit = (level: LevelLike, typeInfo?: TypeInfoLike | null): string | null => {
    if (isSharedBlockLevel(level)) {
        return null;
    }

    return level.edit ?? typeInfo?.edit ?? null;
};

export const resolveLevelAttributes = (level: LevelLike, typeInfo?: TypeInfoLike | null): unknown[] => {
    if (isSharedBlockLevel(level)) {
        return level.attributes ?? [];
    }

    return level.attributes ?? typeInfo?.attributes ?? [];
};

export const filterAttributeSegment = (attributes, segment) => {
    if (!attributes) {
        return [];
    }

    return attributes.filter((attribute) => {
        if (!segment) {
            return !attribute.segment;
        }

        return attribute.segment === segment;
    });
};
